// ms.js — Malay translation for flatpickr
export const Malay = {
    weekdays: {
      shorthand: ['Ah', 'Is', 'Se', 'Ra', 'Kh', 'Ju', 'Sa'],
      longhand: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu',
      ],
    },
    months: {
      shorthand: [
        'Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun',
        'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'
      ],
      longhand: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember',
      ],
    },
    firstDayOfWeek: 1,
  };
  